export default __webpack_public_path__ + "static/media/Flow State Music 8D Audio - Binaural Theta Waves - Improve Concentration.1f8898e6.mp3";